module.exports = __webpack_public_path__ + "static/img/footer_img3.d3535d4e.png";